import {   
    SNAP_SHOT_API_SUCCESS,
    SNAP_SHOT_API_FAIL
} from "./actionTypes";

const INIT_STATE = {
    data: {},
};

const SnapShot_Detail = (state = INIT_STATE, action) => {
    switch (action.type) {
        case SNAP_SHOT_API_SUCCESS:
            return {
                ...state,
                data: action.payload.OK
            };

        case SNAP_SHOT_API_FAIL:
            return {
                ...state,
                data: action.payload.error
            };

        default:
            return state;
    }
}

export default SnapShot_Detail;